import styled from 'styled-components'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import slide2Img from '../../../assets/slide2.png'
import previousArrowImg from '../../../assets/previous-arrow.png'
import nextArrowImg from '../../../assets/next-arrow.png'
import { useCallback, useRef, useEffect, useState } from 'react'
function Page5MobileContents(prop) {
  var settings = {
    dots: false,
    infinite: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  }
  const slickRef = useRef(null)
  const previous = useCallback(() => slickRef.current.slickPrev(), [])
  const next = useCallback(() => slickRef.current.slickNext(), [])

  const selectedGoods = prop.selectedGoods
  const downListener = prop.downListener
  const moveListener = prop.moveListener
  const upListener = prop.upListener

  const [itemList, setItemList] = useState([])
  const [selectedItem, setSelectedItem] = useState({})
  const [fileList, setFileList] = useState([])

  useEffect(() => {
    setItemList(selectedGoods.itemDtoList)
    setSelectedItem(selectedGoods.itemDtoList[0])
  }, [selectedGoods])

  useEffect(() => {
    setFileList(selectedItem?.fileDtoList)
    setTimeout(()=>{ slickRef.current?.slickGoTo(0, true);}, 100);
  }, [selectedItem])

  return (
    <>
      <CustomSlider {...settings} ref={slickRef}>
        {fileList &&
          fileList.map((file, idx) => {
            
            if (file.fileType == 'IMAGE') {
              return (
                <Slide key={file.fileSeq ?? idx}>
                  <SlideImg
                    src={process.env.REACT_APP_BASE_RESOURCES_API + file.filePath}
                  
                    onMouseUp={() => upListener(process.env.REACT_APP_BASE_RESOURCES_API + file.filePath, idx)}
                    onMouseMove={moveListener}
                    onMouseDown={downListener}
                  />
                  <SlideText  dangerouslySetInnerHTML={ {__html: file.fileInfo} }/>

                </Slide>
              )
            }else{
              return (
                <SlideV
                key={file.fileSeq ?? idx}
                onTouchEnd={() => upListener('videoM',idx)}
                onTouchMove={moveListener}
                onTouchStart={downListener}
                >
                  <SlideVideo
                  controls
                    id={'videoM'+idx}
                    src={process.env.REACT_APP_BASE_RESOURCES_API + file.filePath}
                  />
                  <SlideText  dangerouslySetInnerHTML={ {__html: file.fileInfo} }/>

                </SlideV>
              )

            }

          })}
      </CustomSlider>
      
      <ArrowsContainer>
        <Previous onClick={previous}>
          <PreviousArrow src={previousArrowImg} />
        </Previous>
        <Next onClick={next}>
          <NextArrow src={nextArrowImg} />
        </Next>
      </ArrowsContainer>

      <Bottom>
        {selectedItem && selectedGoods && (
          <TextsContainer>
            <Text1>{selectedItem.itemEngName}</Text1>
            <Text2>
              {selectedItem.itemKorName} | {selectedGoods.gsName}
            </Text2>
          </TextsContainer>
        )}
        <Grid>
          {selectedItem &&
            itemList.map((item) => {
              return (
                <Box
                  key={item.itemSeq}
                  selected={item.itemSeq == selectedItem.itemSeq}
                  onClick={() => {
                    setSelectedItem(item)
                  }}
                >
                  {item.itemName}
                </Box>
              )
            })}
        </Grid>
      </Bottom>
    </>
  )
}

const CustomSlider = styled(Slider)`
  height: 375px;
`
const Slide = styled.div`
  height: 375px;
`
const SlideImg = styled.img`
  width: 100%;
  height: 375px;
  object-fit: cover;
`


const SlideV = styled.div`
  height: 375px;
  overflow-y:hidden;
`
const SlideVideo = styled.video`
  height: 375px;
  width:100%;
  object-fit: contain;
`

const SlideText = styled.p`
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 10px;
  letter-spacing: -0.5px;
  text-align: end;
  color: #ffffff;
  margin-top: -50px;
  margin-right: 18.9px;
`;
const ArrowsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 375px;
  margin-top: -375px;
  z-index: 500;
  padding: 0 4px;
  pointer-events: none;
`
const Previous = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 100%;
  cursor: pointer;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
  tap-highlight-color: transparent;
  outline: none;
  user-select: none;
  -webkit-user-select: none;

  &:active {
    background-color: transparent;
  }
`
const Next = styled(Previous)``
const PreviousArrow = styled.img`
  width: 10px;
  height: 18.3px;
  -webkit-tap-highlight-color: transparent;
  pointer-events: none;
  user-select: none;
`
const NextArrow = styled.img`
  width: 10px;
  height: 18.3px;
  -webkit-tap-highlight-color: transparent;
  pointer-events: none;
  user-select: none;
`

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const TextsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 8px;
  margin-top: 46.6px;
  margin-left: 19.8px;
`
const Text1 = styled.p`
  font-family: GMarketSans;
  font-weight: 500;
  font-size: 18.8px;
  color: #2c2a26;
  letter-spacing: 1.5px;
`
const Text2 = styled.p`
  font-family: Noto Sans KR;
  font-weight: normal;
  font-size: 11.8px;
  color: #727272;
  margin-bottom: 3px;
  letter-spacing: -0.3px;
  word-break: keep-all;
`
const Grid = styled.div`
  width: calc(100vw - 19.8px);
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 9.3px 11.2px;
  margin-top: 21px;
  margin-bottom: 100px;
`
const Box = styled.div`
  height: 31.3px;
  background: ${(props) => (props.selected ? '#a2967f' : 'transparent')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12.7px;
  font-family: Noto Sans KR;
  font-weight: normal;
  color: ${(props) => (props.selected ? '#fff' : '#808080')};
  border: ${(props) =>
    props.selected ? '0.3px solid transparent' : '0.3px solid #9D9D9D'};
`
export default Page5MobileContents
